import { BaseModel } from "model/BaseModel";
import Deposito from "./Deposito";
import Produto from "model/administracao/cadastro/produto/Produto";
import Transacao from "./Transacao";
import ItemNotaFiscalEntrada from "./ItemNotaFiscalEntrada";
import Usuario from "model/administracao/cadastro/Usuario";


export default class MovimentoEstoque implements BaseModel {

    id: number;
    codigo: string | null;
    produto: Produto;
    deposito: Deposito;
    lote: string | null;
    sequencial: number;
    dataMovimento: Date;
    quantidade: number;
    valorUnitario: number;
    valorTotal: number;
    tipoMovimento: string;
    validade: Date | null;
    transacao: Transacao;
    itemNotaFiscalEntrada: ItemNotaFiscalEntrada | null;
    usuario: Usuario | null;
    excluirLigacao: boolean;
    transferencia: boolean;
    observacao: string;
    integrado: boolean;

    constructor(
        id = 0,
        codigo = null,
        produto = new Produto(),
        deposito = new Deposito(),
        lote = null,
        sequencial = 0,
        dataMovimento = new Date(),
        quantidade = 0,
        valorUnitario = 0,
        valorTotal = 0,
        tipoMovimento = "",
        validade = null,
        transacao = new Transacao(),
        itemNotaFiscalEntrada = null,
        usuario = null,
        excluirLigacao = false,
        transferencia = false,
        observacao = "",
        integrado: boolean = false
    ) {
        this.id = id;
        this.codigo = codigo;
        this.produto = produto;
        this.deposito = deposito;
        this.lote = lote;
        this.sequencial = sequencial;
        this.dataMovimento = dataMovimento;
        this.quantidade = quantidade;
        this.valorUnitario = valorUnitario;
        this.valorTotal = valorTotal
        this.tipoMovimento = tipoMovimento;
        this.validade = validade;
        this.transacao = transacao;
        this.itemNotaFiscalEntrada = itemNotaFiscalEntrada;
        this.usuario = usuario;
        this.excluirLigacao = excluirLigacao;
        this.transferencia = transferencia;
        this.observacao = observacao;
        this.integrado = integrado;
    }
}
